module.exports = __webpack_public_path__ + "static/media/Alimenticia.1be95e81.jpg";